<template>
  <div class="dashboard">
    <router-view></router-view>
    <!-- <Index/> -->
  </div>
</template>

<script>
 /* eslint-disable */

export default {
  name: "category",
  components:{

  }
};
</script>
